import React from 'react';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative z-10 border-t bg-black/40 backdrop-blur-sm" style={{ borderColor: '#2e2e40' }}>
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="mb-3">
              <img src="/Floor Plan Logo.png" alt="Floor Plan" className="h-10 w-auto object-contain object-left" />
            </div>
            <p className="text-xs text-slate-500 leading-relaxed">
              Draw floor plans quickly in the browser. No CAD required. Add rooms, symbols, and export for credits.
            </p>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: '#FF4C4C' }}>Product</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>Draw Rooms</li>
              <li>Symbol Library</li>
              <li>Export PNG / PDF / SVG</li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: '#FF4C4C' }}>Company</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li><a href="https://hub.rehub.studio" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF4C4C] transition-colors">ReHub Studio</a></li>
              <li><a href="https://hub.rehub.studio/#/contact" className="hover:text-[#FF4C4C] transition-colors">Contact</a></li>
              <li><a href="https://rehub.studio/terms" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF4C4C] transition-colors">Terms</a></li>
              <li><a href="https://rehub.studio/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF4C4C] transition-colors">Privacy</a></li>
            </ul>
          </div>
        </div>
        <div className="pt-6 border-t flex flex-col sm:flex-row items-center justify-between gap-3" style={{ borderColor: 'rgba(46,46,64,0.5)' }}>
          <p className="text-[11px] text-slate-600">&copy; {year} ReHub Studio. All rights reserved.</p>
          <span className="text-[11px] text-slate-600">Part of the ReHub Suite</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
